import React, { useState } from 'react'
import { Button } from '@habitech/call-to-action';
import { methodsName, OneClickOrigin, OriginPayment, payment_method, SourceShoppingCart } from 'src/constants/ShoppingCart';
import { useAppSelector } from 'src/hooks/redux';
import { selectUser } from 'src/redux/user/userSlice';
import { paymentOneClick } from 'src/apis/paymentOneClick';
import { sendMail } from 'src/apis/sendMailApi';
import { SendMailRequest } from 'src/models/SendMail';
import Modal from '../common/modal/Modal';
import { PaymentCtaFooterNotice, WrapperError, WrapperModaPaymentOneClick } from './ButtonPaymentOneClick.styles';
import { TextField } from '@habitech/keychain-atoms-inputs';

export interface DataPaymentOneClick {
  total: number;
  description: string;
  detail: string;
  buttonDisabled: boolean;
  user_id: number;
  type_payment?: any;
  msi_months?: number;
  /** Texto opcional debajo del botón Crear Pago (p. ej. restricciones de método por monto). */
  ctaFooterNotice?: string;
}

const ButtonPaymentOneClick = ({
  total,
  description,
  detail,
  buttonDisabled,
  user_id,
  type_payment,
  msi_months,
  ctaFooterNotice,
}: DataPaymentOneClick) => {

  const { token } = useAppSelector(selectUser);
  const [dataModal, setdataModal] = useState({
    order: "",
    url: "",
    name: "",
    email: "",
    url_pdf: "",
    redirect: "",
  });
  const [error, setError] = useState("");
  const [lodingPayment, setlodingPayment] = useState(false)
  const [showModalSummary, setShowModalSummary] = useState(false);
  const [hasUserInResponse, setHasUserInResponse] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

  const handlePaymentOneClick = async () => {
    setlodingPayment(true)
    setError("")
    const ivaRate = 0.16;
    // Calcular subtotal sin IVA
    const sub_total = total / (1 + ivaRate);
    // Calcular IVA
    const iva = total - sub_total;
    const data = {
      country: "MX",
      sub_total: sub_total,
      iva: iva,
      payment_method: type_payment,
      card_id: "",
      total: total,
      description: description,
      device_session_id: "pago_en_un_click",
      one_click: true,
      source: SourceShoppingCart.CART_V3,
      detail: detail,
      user_id: user_id,
      one_click_origin: OneClickOrigin.CALCULADORA,
      origin: OriginPayment.INT,
      cvv2: "",
      ...(msi_months ? { msi_months } : {}),
    };
    const response = await paymentOneClick(data, token)
    if (response.status === 200) {
      const results = response.response.results;
      const hasUser = !!results.user;
      setHasUserInResponse(hasUser);
      const baseDataModal = {
        order: results.order_id ?? "",
        name: results.user?.name ?? "",
        email: results.user?.email ?? "",
        url_pdf: results.url_pdf ?? "",
        redirect: results.redirect ?? "",
      };
      if(
        type_payment === payment_method[methodsName.CARD_3DS] ||
        type_payment === payment_method[methodsName.CARD]
      ){
        setdataModal({
          ...baseDataModal,
          url: results.redirect,
        })
      }else if(type_payment === payment_method[methodsName.PAYPAL]){
        const link = results.links.find((link: any) => link.rel === 'payer-action')
        setdataModal({
          ...baseDataModal,
          url: link?.href,
        })
      }else{
        setdataModal({
          ...baseDataModal,
          url: results.url_pdf,
        })
      }
      setShowModalSummary(true)
    } else {
      const errorJson = JSON.parse(response.response.message)
      setError(errorJson.message)
    }
    setlodingPayment(false)
  }

  const handleCloseModal = () => {
    setShowModalSummary(false);
  };

  const handleConfirmModal = async () => {
    if (isConfirming) return;
    setIsConfirming(true);
    navigator.clipboard.writeText(dataModal.url);

    if (hasUserInResponse) {
      const payment_id = dataModal.url_pdf || dataModal.redirect || dataModal.url;
      if (dataModal.email && payment_id) {
        const mailPayload: SendMailRequest = {
          country: "MX",
          name: "orden_pago",
          data: {
            name: dataModal.name,
            order_id: dataModal.order,
            payment_id,
          },
          destinataries: [dataModal.email],
          subject: "Link orden de pago",
        };
        try {
          await sendMail(mailPayload, token);
        } catch {
          // El fallo en el envío del correo no interrumpe el flujo de pago
        }
      }
    }

    setIsConfirming(false);
    setShowModalSummary(false);
  };


  return (
    <>
      <Button
        dataId="btn_paymen_one_click"
        onClick={handlePaymentOneClick}
        originType="pcom"
        size="large"
        disabled={buttonDisabled}
        loading={lodingPayment}
      >
        Crear Pago
      </Button>
      {ctaFooterNotice ? (
        <PaymentCtaFooterNotice role="status">{ctaFooterNotice}</PaymentCtaFooterNotice>
      ) : null}
      <WrapperError>
        {error}
      </WrapperError>
      {
        showModalSummary &&
        <Modal onClose={handleCloseModal}>
          <WrapperModaPaymentOneClick>
            <h1>Orden de pago creada.</h1>
            <p>Información de la orden creada.</p>
            <p>
              <b>Order:</b> {dataModal.order}
            </p>
            <div className='WrapperUrl'>
              <TextField
                label='URL'
                dataId="name"
                name="name"
                originType="pcom"
                innerLabel
                value={dataModal.url}
                disabled={true}
              />
              <button
                className='btnCopy'
                data-testid="Copiar"
                onClick={() => navigator.clipboard.writeText(dataModal.url)}
              >
                Copiar
              </button>
            </div>
            <Button
              dataId="aceptar"
              onClick={handleConfirmModal}
              originType="pcom"
              size="extra-large"
              fluid
              disabled={isConfirming}
              loading={isConfirming}
            >
              {hasUserInResponse ? 'Enviar Mail al Usuario' : 'Aceptar y copiar'}
            </Button>
          </WrapperModaPaymentOneClick>
        </Modal>
      }

    </>
  )
}

export default ButtonPaymentOneClick
